var _path, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Tray",
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.652,
    height: 69.835,
    viewBox: "0 0 76.652 69.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17061",
    "data-name": "Path 17061",
    d: "M0,176l2.643,19.4H74.009L76.652,176Z",
    transform: "translate(0 -133.323)",
    fill: "#6391f0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2768",
    "data-name": "Rectangle 2768",
    width: 66.079,
    height: 7.759,
    transform: "translate(5.286 62.076)",
    fill: "#5035ed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17062",
    "data-name": "Path 17062",
    d: "M10.573,0,0,42.677H76.652L66.079,0Z",
    transform: "translate(0)",
    fill: "#98baff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17063",
    "data-name": "Path 17063",
    d: "M32.7,79.038,39.309,48H86.886l6.608,31.038Z",
    transform: "translate(-24.772 -36.361)",
    fill: "#5035ed"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTray);
export default __webpack_public_path__ + "static/media/Tray.9df6fdd9620ef3b2607e8cd69338b0a2.svg";
export { ForwardRef as ReactComponent };